{{ status() | adminProductStatus | async }}
